import React, { useCallback, useEffect, useRef, useState } from "react";
import { DetailDrawer, InnoTable, Popover, TableList } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";
import theme from "@theme";
import AddEditUser from "./AddEditUser";
import { apiGet, apiPost } from "api/callApi";
import DeleteComponent from "../DeleteComponent";
import { useSelector } from "react-redux";
import { getCompany } from "@store/company/actions";
import { useDispatch } from "react-redux";
import AssignRoles from "./AssignRoles";
import SendCredential from "./SendCredential";
import AssignOccupant from "./AssignOccupant";
import TimezoneConverter from "components/TimeZoneConvertor";
import { decryptCrypto, formatPhoneNumber, showAlert } from "utils/helper";
import { innoTableConfigsecond } from "utils/config";
import { getRoleOptions } from "@store/roleOptions/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "lodash/debounce";

const UserTable = (props) => {
  const {
    popupState,
    tableConfig = {
      draggable: false,
      selection: false,
      expandable: true,
      addNew: true,
      search: true,
      action: false,
      sno: false,
      divBorder: true,
      // pagination: {
      //   current: currentPage,
      //   pageSize: innoTableConfigsecond.pageSize,
      //   onChange: (page) => setCurrentPage(page),
      //   total: userData?.total || 0, // Assuming response includes `total`
      // },
      pagination: false,
      searchPlaceholder: "Search by Name, Email, Role and Company",
    },
    selectedItems = [],
    setSelectedItems = () => {},
    userProjectId = null,
    hideColumns = [],
    allowEdit = true,
    companyId = null,
    companyRowData,
    scrollableTarget,
    currentPageP,
    setTotalData = () => {},
    isDisabled = false,
    selectedOnly = false,
    selectedUserIds = [],
    selectedOnlyRefreshKey = 0,
  } = props;
  const [openAddEditDrawer, setOpenAddEditDrawer] = useState(false);
  const [openAssignRoleDrawer, setOpenAssignRoleDrawer] = useState(false);
  const [openAssignProjectDrawer, setOpenAssignProjectDrawer] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [fieldData, setFieldData] = useState();
  const [userData, setUserData] = useState([]);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [openCredentialView, setOpenCredentialView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(innoTableConfigsecond.pageSize);
  const [hasMore, setHasMore] = useState(true);

  const currentUser = useSelector((state) => state?.authdata?.data || {});
  const dispatch = useDispatch();
  const scrollContainerRef = useRef(null);

  const companyData = useSelector((state) => state.companyData || []);
  const roleData = useSelector((state) => state.roleOptionData || []);

  const initialFilters = {
    roles: null,
    status: null,
    companyIds: null,
  };

  const [filters, setFilters] = useState(() => {
    return initialFilters;
  });

  useEffect(() => {
    dispatch(getCompany());
    dispatch(getRoleOptions());
  }, []);

  // console.log(currentPageP, "currentPagePs");

  // useEffect(() => {
  //   if (currentPageP) {
  //     setCurrentPage(currentPageP);
  //   }
  // }, [currentPageP]);

  const statusOptions = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No ",
      value: "No",
    },
  ];

  const companyFilter = {
    filters: companyData?.data?.map((option) => ({
      text: option.companyName,
      value: option.companyName,
    })),
    filterSearch: true,
    // onFilter: (value, record) => record["companyName"] === value,
    onFilter: (value, record) => {
      return true;
    },
  };

  const roleFilter = {
    filters: roleData?.data?.map((option) => ({
      text: option.role,
      value: option.role,
    })),
    filterSearch: true,
    // onFilter: (value, record) => {
    //   return record["roleNames"]?.split(", ").includes(value);
    // },
    onFilter: (value, record) => {
      return true;
    },
  };

  const statusFilter = {
    filters: statusOptions.map((option) => ({
      text: option.label,
      value: option.value,
    })),

    // onFilter: (value, record) => {
    //   const adminStatus = record.userType !== 2 ? "Yes" : "No";
    //   return adminStatus === value;
    // },
    onFilter: (value, record) => {
      return true;
    },
  };

  const getAlldata = async (searchTerm = "") => {
    try {
      setIsLoading(true);
      let url = `/v1/getallusers?page=${currentPage}&limit=${pageSize}`;
      if (userProjectId) {
        url = url + `&getRolesFrom=${userProjectId}`;
      }
      if (companyId) {
        url = url + `&companyId=${companyId}`;
      }
      if (selectedOnly) {
        url += `&selectedOnly=1&selectedUserIds=${encodeURIComponent(
          selectedUserIds.join(","),
        )}`;
      }
      if (searchTerm) {
        url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
      }
      const { roles, status, companyIds } = filters;
      if (roles) {
        url += `&roles=${roles}`;
      }
      if (status) {
        url += `&status=${status}`;
      }
      if (companyIds) {
        url += `&companyIds=${companyIds}`;
      }
      const response = await apiGet(url, false);
      const fetchedData = response.data || [];

      setTotalData(response.total || 0);
      if (currentPage === 1) {
        setUserData(fetchedData);
      } else {
        setUserData((prevData) => [...prevData, ...fetchedData]);
      }
      setHasMore(response.hasMore || fetchedData.length === pageSize);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setUserData([]);
  }, [userProjectId, companyId, currentPageP, selectedOnly, selectedOnlyRefreshKey]);

  useEffect(() => {
    getAlldata(); // Only triggered when currentPage
  }, [
    currentPage,
    userProjectId,
    companyId,
    filters,
    selectedOnly,
    selectedOnlyRefreshKey,
  ]);

  const onEndScroll = () => {
    if (hasMore && !isLoading) {
      setCurrentPage((prev) => prev + 1); // this triggers `getAlldata`
    }
  };

  const onAddDataCallback = () => {
    setOpenAddEditDrawer(true);
    setFieldId("");
    setIsEditing(false);
  };

  const closeAddEditDrawer = () => {
    setOpenAddEditDrawer(false);
    setIsEditing(false);
  };

  const closeAssignRoleDrawer = () => {
    setOpenAssignRoleDrawer(false);
    setIsEditing(false);
  };
  const closeAssignProjectDrawer = () => {
    setOpenAssignProjectDrawer(false);
    setIsEditing(false);
  };

  const onEditClick = (data) => {
    setIsEditing(true);
    setFieldId(data.id);
    setFieldData(data);
    setOpenAddEditDrawer(true);
  };

  const onAssignRoleClick = (data) => {
    setFieldId(data.id);
    setFieldData(data);
    setOpenAssignRoleDrawer(true);
  };
  const onAssignOccupantClick = (data) => {
    setFieldId(data.id);
    setFieldData(data);
    setOpenAssignProjectDrawer(true);
  };

  const onRowClick = (data) => {
    console.log(data, "Row clicked");
  };

  const handleDelete = async (userId) => {
    if (currentUser.id === userId) {
      showAlert({ title: "Your account was deleted", icon: "success" });
      console.log("User deleted self, redirecting...");
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/";
      }, 1000);
      return; // stop execution here
    }

    try {
      const body = {
        users: [userId],
      };
      const response = await apiPost(`/v1/deleteuser`, body, false);
      console.log("Delete Response:", response);
      showAlert({ title: response.message, icon: "success" });
      getAlldata();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    } finally {
      setOpenDeleteView(false);
    }
  };

  const handleArchive = async (userId) => {
    try {
      const body = {
        users: [userId],
        isArchive: true,
      };
      const response = await apiPost(`/v1/deleteuser`, body, false);
      showAlert({ title: response.message, icon: "success" });
      getAlldata();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleCancelCredentials = async (userId) => {
    try {
      setOpenCredentialView(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record.id);
    setFieldData(record);
    setOpenDeleteView(true);
  };

  const handleCredentialOption = async (record) => {
    setOpenCredentialView(true);
    setFieldId(record.id);
    setFieldData(record);
  };

  const renderText = (value) => <SC.ValueSpan>{value}</SC.ValueSpan>;

  const columnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const pageSize = innoTableConfigsecond.pageSize;
        const serialNumberP = (currentPage - 1) * pageSize + index + 1;
        const serialNumber = index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      // sorter: (a, b) => a.fullName.localeCompare(b.fullName),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["descend", "ascend"],
      width: 200,
      onCell: () => ({}),
      render: renderText,
    },
    {
      title: "User Name",
      dataIndex: "userName",
      width: 200,
      onCell: () => ({}),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            onClick: () => onEditClick(record),
          },
          {
            id: 2,
            text: "Manage User Projects",
            onClick: () => onAssignOccupantClick(record),
          },
          {
            id: 3,
            text: "Assign Roles",
            onClick: () => onAssignRoleClick(record),
          },
          {
            id: 4,
            text: "Send Credentials",
            onClick: () => handleCredentialOption(record),
          },
          {
            id: 5,
            text: "Delete",
            onClick: () => handleDeleteOpenModal(record),
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpan onClick={() => onRowClick(record)}>
              {value}
            </SC.ValueSpan>
            {!isDisabled && allowEdit && (
              <Popover
                sx={{
                  cursor: "pointer",
                }}
                buttonLabel={{
                  icon: (
                    <>
                      <div
                        style={{
                          width: "50px",
                          textAlign: "center",
                          justifyContent: "end",
                          display: "flex",
                          marginRight: "5px",
                        }}
                      >
                        <SC.PopoverSpan>
                          <SC.MoreVertIcon />
                        </SC.PopoverSpan>
                      </div>
                    </>
                  ),
                }}
                popoverContent={
                  <TableList
                    sx={{
                      borderBottom: `1px solid ${theme.colors.bordertask}`,
                    }}
                    items={menuItems || []}
                    popupState={popupState}
                  />
                }
              />
            )}
          </SC.PopoverContainer>
        );
      },
    },

    {
      title: "Role",
      width: 450,
      dataIndex: "roleNames",
      render(value, record) {
        return (
          value && (
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <p
                    style={{
                      whiteSpace: "normal",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "100%",
                      padding: "2px",
                    }}
                  >
                    {value}
                  </p>
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {value || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          )
        );
      },
      ...roleFilter,
    },
    {
      title: "Cell",
      dataIndex: "cell",
      width: 200,
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>
              {formatPhoneNumber(
                record.cellCode,
                value ? decryptCrypto(value) : value,
              )}
            </SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      width: 200,
      onCell: () => ({}),
      render: renderText,
      ...companyFilter,
    },
    {
      title: "Email",
      dataIndex: "email",
      onCell: () => ({
        style: { width: "250px" },
      }),
      render: renderText,
    },
    {
      title: "Admin Status",
      dataIndex: "userType",
      width: 20,
      onCell: () => ({}),
      render(value, record) {
        const adminStatus = value !== 2 ? "Yes" : "No";
        return (
          <>
            <SC.ValueSpan>{adminStatus}</SC.ValueSpan>
          </>
        );
      },
      ...statusFilter,
    },
    {
      title: "Created Date & Time",
      dataIndex: "createdAt",
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>
              <TimezoneConverter time={value} />
            </SC.ValueSpan>
          </>
        );
      },
    },
  ];

  const checkboxChangeCallback = (data, state) => {
    setSelectedItems((prevSelectedItems) => {
      if (state === true) {
        return prevSelectedItems.includes(data)
          ? prevSelectedItems
          : [data, ...prevSelectedItems];
      }
      return prevSelectedItems.filter((item) => data !== item);
    });
  };

  const allCheckboxChangeCallback = (data, state) => {
    const currentPageIds = data.length > 0 ? data : userData.map((item) => item.id);

    setSelectedItems((prevSelectedItems) => {
      if (state === true) {
        return [...new Set([...prevSelectedItems, ...currentPageIds])];
      }
      return prevSelectedItems.filter((item) => !currentPageIds.includes(item));
    });
  };

  const filteredColumnData = columnData.filter(
    (column) => !hideColumns.includes(column.dataIndex),
  );

  const handleScroll = useCallback(() => {
    const scrollElement = scrollContainerRef.current;
    if (!scrollElement || isLoading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollElement;

    // When the user scrolls to the bottom
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      onEndScroll();
    }
  }, [isLoading, hasMore, onEndScroll]);

  useEffect(() => {
    const scrollElement = scrollContainerRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const debounceSearch = useRef(
    debounce((term) => {
      setCurrentPage(1);
      getAlldata(term);
    }, 500),
  ).current;

  useEffect(() => {
    return () => {
      debounceSearch.cancel(); // Cancel pending debounce on unmount
    };
  }, []);

  const onFilterChange = (data) => {
    const { userType, roleNames, companyName } = data;

    setFilters((prevFilters) => ({
      ...prevFilters,
      roles: roleNames,
      status: userType,
      companyIds: companyName,
    }));

    // Always reset to first page when filter changes
    setCurrentPage(1);
  };

  return (
    <>
      <div
        ref={scrollContainerRef}
        style={{
          height: "calc(100vh - 130px)",
          overflow: "auto",
        }}
      >
        <InnoTable
          tableConfig={tableConfig}
          column={filteredColumnData}
          data={userData}
          tableKey={"User"}
          onAddDataCallback={onAddDataCallback}
          onRowClickCallback={onRowClick}
          searchKeys={[
            "userName",
            "fullName",
            "email",
            "companyName",
            "roleNames",
          ]}
          ComponnentName={"Users"}
          loading={isLoading}
          selectedItems={selectedItems}
          checkboxChangeCallback={checkboxChangeCallback}
          allCheckboxChangeCallback={allCheckboxChangeCallback}
          onSearch={(value) => {
            setCurrentPage(1); // reset pagination if you're paginating
            getAlldata(value);
            debounceSearch(value);
          }}
          onFilterChange={onFilterChange}
        />
        {isLoading && <div style={{ padding: "1rem" }}>{isLoading}</div>}
        {/* {!hasMore && <div style={{ padding: "1rem" }}>No more data</div>} */}
      </div>
      {openDeleteView && (
        <DeleteComponent
          title={"Delete User"}
          messageData={`Are you sure you want to delete user ${
            fieldData?.fullName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
      {openCredentialView && (
        <SendCredential
          title={"Send Credentials"}
          handleShow={setOpenCredentialView}
          isOpen={openCredentialView}
          data={fieldData}
        />
      )}

      {openAddEditDrawer && (
        <DetailDrawer
          open={openAddEditDrawer}
          onClose={closeAddEditDrawer}
          width={"650px"}
          children={
            <AddEditUser
              userdata={fieldData}
              onClose={closeAddEditDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              fetchData={getAlldata}
              companyId={
                companyRowData?.status == 1 ? companyRowData?.id : null
              }
              setCurrentPage={setCurrentPage}
              isDisabled={isDisabled}
            />
          }
        />
      )}

      {openAssignRoleDrawer && (
        <DetailDrawer
          open={openAssignRoleDrawer}
          onClose={closeAssignRoleDrawer}
          width={"750px"}
          children={
            <AssignRoles
              userdata={fieldData}
              onClose={closeAssignRoleDrawer}
              fetchData={getAlldata}
              // defaultProject={userProjectId}
              setOpenAssignRoleDrawer={setOpenAssignRoleDrawer}
              setCurrentPage={setCurrentPage}
            />
          }
        />
      )}
      {openAssignProjectDrawer && (
        <DetailDrawer
          open={openAssignProjectDrawer}
          onClose={closeAssignProjectDrawer}
          width={"50%"}
          children={
            <AssignOccupant
              userdata={fieldData}
              onClose={closeAssignProjectDrawer}
              fetchData={getAlldata}
              setOpenAssignProjectDrawer={setOpenAssignProjectDrawer}
              setCurrentPage={setCurrentPage}
            />
          }
        />
      )}
    </>
  );
};

export default UserTable;
